import { Crown } from "lucide-react";

export const PremiumBadge = ({ className = "", showLabel = true, size = "sm" }) => {
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  const icon = size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";
  return (
    <span
      data-testid="premium-badge"
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wide ${pad} bg-amber-400/15 border border-amber-400/40 text-amber-300 ${className}`}
    >
      <Crown className={icon} />
      {showLabel && "Premium"}
    </span>
  );
};
